import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_f8d2cdf2: FaireBrandEntity = {
  token: "b_f8d2cdf2",
  type: "brand",
  name: "The Blueberry Hill",
  avatarUrl:
    "https://cdn.faire.com/fastly/648f96f496f35ec50b0cc490e0b84009da41858548c4984204c07a892604e2c6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7b6ac18a3cd4d3ddea6f39d23b3bb5f675f63f304dcab5ba8cc5e21d3d62e145.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/648f96f496f35ec50b0cc490e0b84009da41858548c4984204c07a892604e2c6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7b6ac18a3cd4d3ddea6f39d23b3bb5f675f63f304dcab5ba8cc5e21d3d62e145.jpeg",
  location: "Salt Lake City, UT, USA",
  minimumOrderDollars: 350,
  rating: 5,
  reviewCount: 225,
  isTopShop: true,
  isInsider: true,
  description:
    "The Blueberry Hill creates unique, meaningful baby gifts to connect families and loved ones and provide support for families coping with child loss. Our products are designed in-house, handmade by knitters and crocheters or are certified organic, and packaged with care. As a Certified B Corporation, we are part of a global network of People Using Business as a Force for Good. We seek to have a positive impact through sustainability efforts, donations to the Child Loss Foundation, and handmade gifts that provide joy and comfort.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:52.580Z",
    importedBy: "entity-db-cli",
  },
};
